const styles = (theme) => ({
  root: {
    backgroundColor: '#0CB044',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    flexDirection: 'column',
    padding: '15px 24px 15px 24px',

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },

    [theme.breakpoints.up('xl')]: {
      padding: '15px 0',
      width: '1400px',
      margin: '0 auto',
    },
  },
  textWrapper: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',

    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: '320px',
    marginTop: '15px',

    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      justifyContent: 'flex-end',
    },
  },
  message: {
    color: 'black',
    fontSize: '18px',

    '& p': {
      marginBottom: 0,
    },

    '& a': {
      color: 'black',
      textDecoration: 'underline',

      '&:hover': {
        textDecorationColor: '#F6F9EA',
      },
    },
  },
  button: {
    backgroundColor: '#0CB044',
    height: '37px',
    margin: '0px 5px',
    color: 'black',
    border: '1px solid black',

    [theme.breakpoints.up('md')]: {
      margin: '0 0 0 10px',

      '&:first-of-type': {
        marginLeft: 0,
      },
    },

    [theme.breakpoints.up('sm')]: {
      height: '40px',
    },

    '&:hover': {
      backgroundColor: '#F6F9EA !important',
      color: 'black !important',
      border: '1px solid #F6F9EA !important',
    },
  },
});

export default styles;
